export let ExperimentKeys;
(function (ExperimentKeys) {
  ExperimentKeys["ACQ0167"] = "acq-0167";
  ExperimentKeys["ACQ0168"] = "acq-0168";
  ExperimentKeys["ACQ0170"] = "acq-0170";
})(ExperimentKeys || (ExperimentKeys = {}));
export const getExperimentKeys = () => {
  return Object.values(ExperimentKeys);
};
export const TEST_KEY = 'TEST-002';